import React, {useContext, useEffect, useState} from "react";
import PropTypes from "prop-types";
import Button from "../../../components/bootstrap/Button";
import {HeaderRight} from "../../../layout/Header/Header";
import ThemeContext from "../../../contexts/themeContext";
import useDarkMode from "../../../hooks/useDarkMode";
import Popovers from "../../../components/bootstrap/Popovers";
import {useNavigate} from "react-router-dom";
import {messaging} from "../../../notification/firebase";
import {onMessage} from "firebase/messaging";
import useStore from "../../../hooks/useStore";
import Toasts from "../../../components/bootstrap/Toasts";
import {useToasts} from "react-toast-notifications";
import {baseUrl} from "../../../helpers/helpers";
import useData from "../../../hooks/useData";
// eslint-disable-next-line react/prop-types
const CommonHeaderRight = ({ beforeChildren, afterChildren }) => {
	const { darkModeStatus, setDarkModeStatus } = useDarkMode();
	const { addToast } = useToasts();
	const {token} = useData()

	const { fullScreenStatus, setFullScreenStatus } = useContext(ThemeContext);
	const styledBtn = {
		color: darkModeStatus ? 'dark' : 'light',
		hoverShadow: 'default',
		isLight: !darkModeStatus,
		size: 'lg',
	};
	const navigate = useNavigate()
	const {notificationsList,setNotificationUpdate,notificationUpdate} = useStore()



	const [notificationCount,setNotificationCount] = useState(0)
	useEffect(() => {
		if (!token){
			return
		}
		const notificationCountGet = async ()=>{
			try {
				const res = await fetch(`${baseUrl.url}/api/unread_notification`, {
					method: 'GET',
					headers: {
						Authorization: `bearer ${token}`,
					},
				});
				const data = await res.json();
				if (res.ok) {
					setNotificationCount(data.data)
				}
			}catch (e) {
				console.log(e);
			}
		}
		notificationCountGet().then()
	}, [token,notificationUpdate]);


	useEffect(() => {

		// Listen for foreground messages
		const unsubscribe = onMessage(messaging, (payload) => {
			const {title,body} = payload.notification
			setNotificationUpdate(!notificationUpdate)
			addToast(
				<Toasts title={title} icon='Info' iconColor='info' time='Now' isDismiss>
					{body}
				</Toasts>,
				{
					autoDismiss: true,
				},
			);
		});

		// Cleanup listener on unmount
		return () => unsubscribe();
	}, [notificationsList,notificationUpdate,addToast]);



	return (
		<HeaderRight>
			<div className='row g-3'>
				{beforeChildren}
				{/* Dark Mode */}
				<div className='col-auto'>
					<Popovers trigger='hover' desc='Dark / Light mode'>
						<Button
							// eslint-disable-next-line react/jsx-props-no-spreading
							{...styledBtn}
							icon={darkModeStatus ? 'DarkMode' : 'LightMode'}
							onClick={() => setDarkModeStatus(!darkModeStatus)}
							aria-label='Toggle fullscreen'
							data-tour='dark-mode'
						/>
					</Popovers>
				</div>

				{/*	Full Screen */}
				<div className='col-auto'>
					<Popovers trigger='hover' desc='Fullscreen'>
						<Button
							// eslint-disable-next-line react/jsx-props-no-spreading
							{...styledBtn}
							icon={fullScreenStatus ? 'FullscreenExit' : 'Fullscreen'}
							onClick={() => setFullScreenStatus(!fullScreenStatus)}
							aria-label='Toggle dark mode'
						/>
					</Popovers>
				</div>

				{/*	Notifications ==================================================================================================================*/}
				<div className='col-auto'>
					<Button
						// eslint-disable-next-line react/jsx-props-no-spreading
						{...styledBtn}
						icon='Notifications'
						className='btn-only-icon position-relative'
						onClick={() => navigate("/settings/notification")}
						aria-label='Notifications'>
						<div style={{height:'15px',width:'15px'}} className='position-absolute d-flex align-items-center justify-content-center text-white top-30 start-70 translate-middle rounded-circle bg-danger'>
									<span style={{fontSize:8}}>
										{notificationCount}
									</span>
						</div>
					</Button>
				</div>
				{afterChildren}
			</div>
		</HeaderRight>
	);
};
CommonHeaderRight.propTypes = {
	beforeChildren: PropTypes.node,
	afterChildren: PropTypes.node,
};
CommonHeaderRight.defaultProps = {
	beforeChildren: null,
	afterChildren: null,
};

export default CommonHeaderRight;
